// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.argent",
    name: "Argent",
    homepage: "https://www.argent.xyz",
    image_id: "215158d2-614b-49c9-410f-77aa661c3900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/argent-defi-in-a-tap/id1358741926",
        android: "https://play.google.com/store/apps/details?id=im.argent.contractwalletclient&hl=en&gl=US&pli=1",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "argent://app/",
        universal: "https://www.argent.xyz/app",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map